import { Trade } from "../components/Trade"

export function TradePage() {
    return (
        <>
            <Trade/>
        </>
    )
}
